import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SettingsService } from '../../../../../../core/services/settings.service';
import { firstValueFrom } from 'rxjs';
import { toast } from 'ngx-sonner';

import { Dialog } from 'primeng/dialog';
import { SharedModule } from 'primeng/api';
import { AppButton } from '../../../../../../shared/components/app-button/app-button';

@Component({
  selector: 'app-dtp-delete-modal',
  standalone: true,
  imports: [
    CommonModule, 
    TranslateModule,
    Dialog,
    SharedModule,
    AppButton
  ],
  templateUrl: './dtp-delete-modal.html',
})
export class DtpDeleteModal {
  @Input() treatmentId: number | null = null;
  @Input() item: any = null;
  @Input() type: 'procedure' = 'procedure';
  
  @Output() close = new EventEmitter<void>();
  @Output() deleted = new EventEmitter<void>();

  private settingsService = inject(SettingsService);
  private translate = inject(TranslateService);

  saving = false;

  async delete() {
    this.saving = true;
    try {
      if (this.type === 'procedure') {
        await firstValueFrom(this.settingsService.unlinkProcedureFromTreatment(this.treatmentId!, (this.item as any).id));
      }
      toast.success(this.translate.instant('delete_success'));
      this.deleted.emit();
    } catch (err) {
      console.error(err);
      toast.error(this.translate.instant('error_deleting_data'));
    } finally {
      this.saving = false;
    }
  }
}
